module.exports = __webpack_public_path__ + "img/337.ba690629.png";